module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.versions.length) ? _c('div', {
    staticClass: "jv-versions"
  }, [_c('div', {
    staticClass: "jv-versions-head"
  }, [_vm._v("Versions")]), _vm._v(" "), _c('div', {
    staticClass: "jv-versions-list"
  }, _vm._l((_vm.versions), function(v) {
    return _c('div', {
      key: v.id,
      staticClass: "jv-version-item",
      class: {
        active: v.versionNumber === _vm.activeVersionNumber
      },
      on: {
        "click": function($event) {
          return _vm.$emit('select', v)
        }
      }
    }, [_c('div', {
      staticClass: "jv-version-row"
    }, [_c('span', {
      staticClass: "jv-version-badge"
    }, [_vm._v("v" + _vm._s(v.versionNumber))]), _vm._v(" "), _c('span', {
      staticClass: "jv-version-time"
    }, [_vm._v(_vm._s(_vm.relativeTime(v.createdAt)))])]), _vm._v(" "), _c('div', {
      staticClass: "jv-version-notes"
    }, [_vm._v(_vm._s(v.notes || 'No description provided.'))])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ae9b131e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/JourneyVersionList.vue
// module id = vLKU
// module chunks = 1